import React from 'react';

// https://stackoverflow.com/questions/680929
const fileType = /(?:\.([^.]+))?$/;

// https://stackoverflow.com/questions/5717093
const validUrl = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', // fragment locator
  'i',
);

const ImagesRenderer = ({ src, ...props }) => {
  if (fileType.exec(src)[1] === 'mp4') {
    return (
      <video className="outline-none" width="100%" controls>
        <source
          src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${src}`}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    );
  }
  if (validUrl.test(src)) {
    return <img src={src} {...props} />;
  }
  return <img src={`${process.env.NEXT_PUBLIC_ASSET_HOST}${src}`} {...props} />;
};

export default ImagesRenderer;
